export const TransferIcon = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6545 14.7273C18.6545 11.4739 21.292 8.83643 24.5455 8.83643H59.8909C63.1444 8.83643 65.7818 11.4739 65.7818 14.7273V81.491C65.7818 84.7444 63.1444 87.3819 59.8909 87.3819H24.5455C21.292 87.3819 18.6545 84.7444 18.6545 81.491V14.7273Z"
      fill="#FFC645"
    />
    <path
      d="M24.5454 16.6909C24.5454 15.6064 25.4246 14.7273 26.509 14.7273H57.9272C59.0117 14.7273 59.8909 15.6064 59.8909 16.6909V69.7091C59.8909 70.7936 59.0117 71.6727 57.9272 71.6727H26.509C25.4246 71.6727 24.5454 70.7936 24.5454 69.7091V16.6909Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M47.1272 22.5818C47.1272 19.3284 49.7646 16.6909 53.0181 16.6909H88.3636C91.617 16.6909 94.2545 19.3284 94.2545 22.5818V89.3455C94.2545 92.5989 91.617 95.2364 88.3636 95.2364H53.0181C49.7646 95.2364 47.1272 92.5989 47.1272 89.3455V22.5818Z"
      fill="#EE4D2D"
    />
    <path
      d="M53.0181 24.5454C53.0181 23.4609 53.8972 22.5818 54.9817 22.5818H86.3999C87.4844 22.5818 88.3635 23.4609 88.3635 24.5454V77.5636C88.3635 78.6481 87.4844 79.5272 86.3999 79.5272H54.9817C53.8972 79.5272 53.0181 78.6481 53.0181 77.5636V24.5454Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.3353 37.1901C57.4856 36.0398 59.3505 36.0398 60.5008 37.1901L74.7372 51.4265C75.8875 52.5767 75.8875 54.4417 74.7372 55.592L60.5008 69.8283C59.3505 70.9786 57.4856 70.9786 56.3353 69.8283C55.185 68.6781 55.185 66.8131 56.3353 65.6628L65.5435 56.4547H37.309C35.6823 56.4547 34.3635 55.1359 34.3635 53.5092C34.3635 51.8825 35.6823 50.5638 37.309 50.5638H65.5435L56.3353 41.3556C55.185 40.2053 55.185 38.3404 56.3353 37.1901Z"
      fill="white"
    />
    <path
      d="M73.6363 87.3817C73.6363 89.0085 72.3175 90.3272 70.6908 90.3272C69.0641 90.3272 67.7454 89.0085 67.7454 87.3817C67.7454 85.755 69.0641 84.4363 70.6908 84.4363C72.3175 84.4363 73.6363 85.755 73.6363 87.3817Z"
      fill="#FD9E8B"
    />
    <path
      d="M45.1636 79.5272C45.1636 81.154 43.8449 82.4727 42.2182 82.4727C40.5914 82.4727 39.2727 81.154 39.2727 79.5272C39.2727 77.9005 40.5914 76.5818 42.2182 76.5818C43.8449 76.5818 45.1636 77.9005 45.1636 79.5272Z"
      fill="#FFE29F"
    />
  </svg>
);
